import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const customImg = 'http://geel.fp.08wx.cn/images/31c4f15c68d24674dccf20e12cc8f1c7.jpg';

const COPY = {
  'zh-CN': {
    title: '大客户定制版',
    highlight: '机构级专属方案',
    desc: '专为机构客户、大型券商或监管合规要求高的场景打造。私有化部署保障数据主权，暗池交易保护机构隐私，深度风控引擎与多司法辖区合规体系，满足最严格的监管要求。',
    cta: '联系机构销售团队',
    badgeTitle: '大客户专属',
    badgeSub: '私有部署 · 机构级',
    jTitle: '全球合规司法辖区支持',
    jFoot: '合规架构由专业律所合作完成，按司法辖区定制文件',
    features: [
      { icon: 'ri-building-4-line', title: '专属私有化部署', desc: '完全隔离的独立服务器环境，数据主权完全归属客户，支持私有云/混合云/本地机房' },
      { icon: 'ri-vip-diamond-line', title: '大宗交易 / 暗池', desc: '机构级 OTC 大宗交易模块，暗池撮合引擎，保护大单交易隐私，价格影响最小化' },
      { icon: 'ri-code-box-line', title: '机构级 API 对接', desc: '专属 FIX 协议 API、WebSocket 推送、RESTful 全套接口，支持 HFT 量化策略接入' },
      { icon: 'ri-shield-star-line', title: '深度风控系统', desc: '自定义风控规则引擎、AI 异常行为检测、实时头寸管理与强制平仓机制' },
      { icon: 'ri-fingerprint-line', title: '交易隐私保护', desc: '零知识证明交易验证、加密订单簿、合规级隐私披露，满足机构合规需求' },
      { icon: 'ri-customer-service-2-line', title: '专属技术顾问团队', desc: '1 对 1 技术顾问、专属项目经理、24/7 优先级响应通道，SLA 可定制' },
    ],
    jurisdictions: [
      { name: 'MAS', region: '新加坡', color: '#FF2D78' },
      { name: 'SFC', region: '香港', color: '#FF8C42' },
      { name: 'MiCA', region: '欧盟', color: '#FF2D78' },
      { name: 'FinCEN', region: '美国', color: '#FF8C42' },
      { name: 'CIMA', region: '开曼', color: '#FF2D78' },
      { name: 'FSC', region: '毛里求斯', color: '#FF8C42' },
    ],
  },
  en: {
    title: 'Enterprise Custom Edition',
    highlight: 'Institutional-Grade Dedicated Solution',
    desc: 'Built for institutions, large brokerages, and high-compliance scenarios. Private deployment ensures data sovereignty, dark-pool trading protects institutional privacy, and deep risk controls with multi-jurisdiction compliance meet strict regulatory requirements.',
    cta: 'Contact Institutional Sales',
    badgeTitle: 'Enterprise Dedicated',
    badgeSub: 'Private Deployment · Institutional Grade',
    jTitle: 'Global Compliance Jurisdictions',
    jFoot: 'Compliance architecture is delivered with partner law firms and customized per jurisdiction.',
    features: [
      { icon: 'ri-building-4-line', title: 'Dedicated Private Deployment', desc: 'Fully isolated infrastructure with full client data sovereignty across private cloud, hybrid cloud, or on-prem.' },
      { icon: 'ri-vip-diamond-line', title: 'Block Trades / Dark Pool', desc: 'Institutional OTC module and dark-pool matching to minimize market impact for large orders.' },
      { icon: 'ri-code-box-line', title: 'Institutional API Integration', desc: 'Dedicated FIX API, WebSocket streaming, and REST interfaces for HFT strategy integration.' },
      { icon: 'ri-shield-star-line', title: 'Advanced Risk Control', desc: 'Custom rules engine, AI anomaly detection, real-time position management, and liquidation controls.' },
      { icon: 'ri-fingerprint-line', title: 'Trading Privacy Protection', desc: 'ZK verification, encrypted order books, and compliant privacy disclosure for institutional use.' },
      { icon: 'ri-customer-service-2-line', title: 'Dedicated Advisory Team', desc: '1:1 technical advisory, dedicated PM, and 24/7 priority support with customizable SLA.' },
    ],
    jurisdictions: [
      { name: 'MAS', region: 'Singapore', color: '#FF2D78' },
      { name: 'SFC', region: 'Hong Kong', color: '#FF8C42' },
      { name: 'MiCA', region: 'EU', color: '#FF2D78' },
      { name: 'FinCEN', region: 'US', color: '#FF8C42' },
      { name: 'CIMA', region: 'Cayman', color: '#FF2D78' },
      { name: 'FSC', region: 'Mauritius', color: '#FF8C42' },
    ],
  },
  'zh-TW': {
    title: '大客戶定制版',
    highlight: '機構級專屬方案',
    desc: '專為機構客戶、大型券商或監管合規要求高的場景打造。私有化部署保障數據主權，暗池交易保護機構隱私，深度風控引擎與多司法轄區合規體系，滿足最嚴格的監管要求。',
    cta: '聯繫機構銷售團隊',
    badgeTitle: '大客戶專屬',
    badgeSub: '私有部署 · 機構級',
    jTitle: '全球合規司法轄區支持',
    jFoot: '合規架構由專業律所合作完成，按司法轄區定制文件',
    features: [
      { icon: 'ri-building-4-line', title: '專屬私有化部署', desc: '完全隔離的獨立服務器環境，數據主權完全歸屬客戶，支持私有雲/混合雲/本地機房' },
      { icon: 'ri-vip-diamond-line', title: '大宗交易 / 暗池', desc: '機構級 OTC 大宗交易模塊，暗池撮合引擎，保護大單交易隱私，價格影響最小化' },
      { icon: 'ri-code-box-line', title: '機構級 API 對接', desc: '專屬 FIX 協議 API、WebSocket 推送、RESTful 全套接口，支持 HFT 量化策略接入' },
      { icon: 'ri-shield-star-line', title: '深度風控系統', desc: '自定義風控規則引擎、AI 異常行為檢測、實時頭寸管理與強制平倉機制' },
      { icon: 'ri-fingerprint-line', title: '交易隱私保護', desc: '零知識證明交易驗證、加密訂單簿、合規級隱私披露，滿足機構合規需求' },
      { icon: 'ri-customer-service-2-line', title: '專屬技術顧問團隊', desc: '1 對 1 技術顧問、專屬項目經理、24/7 優先級響應通道，SLA 可定制' },
    ],
    jurisdictions: [
      { name: 'MAS', region: '新加坡', color: '#FF2D78' },
      { name: 'SFC', region: '香港', color: '#FF8C42' },
      { name: 'MiCA', region: '歐盟', color: '#FF2D78' },
      { name: 'FinCEN', region: '美國', color: '#FF8C42' },
      { name: 'CIMA', region: '開曼', color: '#FF2D78' },
      { name: 'FSC', region: '毛里求斯', color: '#FF8C42' },
    ],
  },
} as const;

function getLocale(lng: string) {
  if (lng.startsWith('en')) return 'en';
  if (lng.startsWith('zh-TW')) return 'zh-TW';
  return 'zh-CN';
}

export default function CexCustomSection() {
  const { i18n } = useTranslation();
  const copy = COPY[getLocale(i18n.resolvedLanguage || i18n.language || 'zh-CN')];

  return (
    <section id="custom" className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 xl:gap-20 items-start">
          <div>
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-accent/10 border border-accent/20 rounded-full">
              <i className="ri-vip-diamond-line text-accent text-xs" />
              <span className="text-accent text-xs font-medium uppercase tracking-widest">Enterprise Custom</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4 leading-tight">
              {copy.title}
              <br />
              <span className="text-accent">{copy.highlight}</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">{copy.desc}</p>

            <div className="space-y-3 mb-8">
              {copy.features.map((f, i) => (
                <div key={i} className="flex items-start gap-4 p-4 bg-light-alt border border-accent/10 rounded-xl hover:border-accent/25 transition-all duration-200">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent/10 border border-accent/20 flex-shrink-0 mt-0.5">
                    <i className={`${f.icon} text-sm text-accent`} />
                  </div>
                  <div>
                    <h4 className="text-gray-800 text-sm font-medium mb-1">{f.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent text-white font-semibold text-sm rounded-xl hover:bg-accent-dark transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-customer-service-line" />
              {copy.cta}
            </Link>
          </div>

          <div className="space-y-5">
            <div className="relative rounded-2xl overflow-hidden border border-accent/15">
              <div className="w-full h-[320px]">
                <img src={customImg} alt="Enterprise Custom CEX" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-transparent" />
              </div>
              <div className="absolute top-4 right-4 bg-white/95 border border-accent/25 rounded-xl px-4 py-3 backdrop-blur-sm">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-vip-diamond-line text-accent text-sm" />
                  <span className="text-gray-800 text-xs font-medium">{copy.badgeTitle}</span>
                </div>
                <div className="text-gray-400 text-xs">{copy.badgeSub}</div>
              </div>
            </div>

            <div className="bg-light-alt border border-primary/10 rounded-2xl p-6">
              <div className="text-xs text-gray-400 uppercase tracking-wider mb-4">{copy.jTitle}</div>
              <div className="grid grid-cols-3 gap-3">
                {copy.jurisdictions.map((j, i) => (
                  <div key={i} className="bg-white border border-primary/10 rounded-xl p-3 text-center">
                    <div className="text-lg font-heading font-black mb-1" style={{ color: j.color }}>{j.name}</div>
                    <div className="text-xs text-gray-400">{j.region}</div>
                  </div>
                ))}
              </div>
              <div className="mt-4 text-xs text-gray-400 text-center">{copy.jFoot}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
